import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PalletStockService } from 'src/app/application/service/PalletStockService';
import { PalletStockImportProcessStatus } from 'src/app/domain/enums/pallet-stock-import-process-status';
import { PalletStockImport } from 'src/app/domain/models/PalletStock';

@Component({
  selector: 'app-import-processes-table',
  templateUrl: './import-processes-table.component.html',
  styleUrls: ['./import-processes-table.component.css']
})
export class ImportProcessesTableComponent {
  @Input() processes: PalletStockImport[] = [];
  @Input() loading: boolean = false;

  constructor(public translate: TranslateService,
    private _palletStockService: PalletStockService,
    private _messageService: MessageService
  ) {
 }

  PalletStockImportProcessStatus = PalletStockImportProcessStatus;

  getImportStatusLabel(status: number): string {
    switch (status) {
      case PalletStockImportProcessStatus.Pending:
        return this.translate.instant(
          'UserPalletStock.PalletStockImport.StatusPending'
        );

      case PalletStockImportProcessStatus.Processing:
        return this.translate.instant(
          'UserPalletStock.PalletStockImport.StatusProcessing'
        );

      case PalletStockImportProcessStatus.Completed:
        return this.translate.instant(
          'UserPalletStock.PalletStockImport.StatusCompleted'
        );

      case PalletStockImportProcessStatus.Failed:
        return this.translate.instant(
          'UserPalletStock.PalletStockImport.StatusFailed'
        );

      default:
        return this.translate.instant(
          'UserPalletStock.PalletStockImport.StatusUnknown'
        );
    }
  }

  downloadImportErrors(process: PalletStockImport)
  {
    this._palletStockService.downloadPalletStockImportErrors(process.id).subscribe({
      next: (resultBlob) => {
        const contentDisposition = resultBlob.headers.get('content-disposition');
        let fileName = `import-errors-${process.id}.txt`;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^";]+)"?/);
          if (match && match[1]) {
            fileName = match[1];
          }
        }

        const link = document.createElement('a');
        const url = URL.createObjectURL(new Blob([resultBlob.body], { type: 'text/plain' }));
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
      },
      error: (e) => {
        console.log(e)
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.DownloadImportErrorsError') })
      }
    })
  }
}
